import React, { useMemo } from 'react';
import DT from 'duration-time-conversion';
import { searchValueInText } from '../../utils';
import useCurrentItemIndex from '../../utils/useCurrentItemIndex';
import TranscriptItem from '../TranscriptItem';
import PlaceholderEmpty from '../PlaceholderEmpty';
import OPTIONS from '../ViewsSelector/options';

const option = OPTIONS.find((o) => o.value === 'actions') || {};
const ENTITY = option.text || 'Actions';
const ICON = option.icon;

const Actions = ({
  actions = [], searchValue, currentTime, setVideoPlayerCurrentTime, revisionId, assetId,
}) => {
  const items = useMemo(() => {
    const result = actions
      .sort((a, b) => DT.t2d(a.startTime) - DT.t2d(b.startTime))
      .map((a, i) => ({ ...a, title: `Action ${i + 1}`, i }));

    if (searchValue) {
      return result.filter(({ text }) => text.toLowerCase().includes(searchValue.toLowerCase()));
    }
    return result;
  }, [actions, searchValue]);

  const [activeItemIndex, setTime] = useCurrentItemIndex(items, currentTime, setVideoPlayerCurrentTime);

  if (!items.length) return <PlaceholderEmpty entity={ENTITY} icon={ICON} isSearch={!!searchValue} />;

  return items.map(({
    startTime, endTime, text, title, i,
  }) => (
    <TranscriptItem
      key={startTime + endTime + text}
      isActive={activeItemIndex === i}
      setVideoPlayerCurrentTime={setTime}
      activeRevisionID={revisionId}
      startTime={startTime}
      speaker={title}
      isNewSpeaker
      endTime={endTime}
      text={searchValueInText(text, searchValue)}
      assetId={assetId}
      clickEvent="VideoIntelligenceActionEntityClicked"
    />
  ));
};

export default Actions;
